import axios from "axios";
import { endpoint, authEndpoint, filesEndpoint } from "../configs/variantsConfig.js";

/**
 * Helper function to make operation-based API calls
 * Caller specifies which endpoint to use: 'auth', 'files', or defaults to 'query'
 */
export const callOperation = async (operation, parameters = {}, token, endpointType = 'query') => {
  const headers = {};
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  // Map endpoint types to actual endpoints
  const endpoints = {
    auth: authEndpoint,
    files: filesEndpoint,
    query: endpoint
  };

  const targetEndpoint = endpoints[endpointType] || endpoint;

  const response = await axios.post(
    targetEndpoint,
    {
      operation: operation,
      parameters: parameters,
    },
    {
      headers: headers,
    }
  );

  return response.data;
};

// Add interceptor to handle 401s globally
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Dispatch custom event for App.js to handle
      window.dispatchEvent(new Event('auth:unauthorized'));
    }
    return Promise.reject(error);
  }
);
